/**
 * Parse a raw amount string into a number. An empty (or whitespace-only)
 * field, or anything that isn't a finite number, becomes null.
 */
export const parseAmount = (raw: string): number | null => {
  if (raw.trim() === "") return null;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
};
